import {
  VENDORS_LIST_REQUEST,
  VENDORS_LIST_SUCCESS,
  VENDORS_LIST_FAILURE,
  VENDOR_GET_FULFILMENT_HUBS_SUCCESS,
  VENDOR_GET_FULFILMENT_HUBS_FAILURE,
  VENDOR_DETAILS_GET_REQUEST,
  VENDOR_DETAILS_GET_SUCCESS,
  VENDOR_DETAILS_GET_FAILURE,
  VENDOR_DETAILS_META_GET_SUCCESS,
  VENDOR_DETAILS_CLEAR,
  VENDOR_ONCHANGE_DETAILS,
  VENDOR_ONCHANGE_INFO,
  VENDOR_DETAILS_SAVE_REQUEST,
  VENDOR_DETAILS_SAVE_SUCCESS,
  VENDOR_DETAILS_SAVE_FAILURE,
  VENDOR_DETAILS_TOGGLE_CONFIRM_MODAL,
  VENDOR_TOGGLE_INACTIVE_REQUEST,
  VENDOR_TOGGLE_INACTIVE_SUCCESS,
  VENDOR_TOGGLE_INACTIVE_FAILURE,
  VENDOR_TOGGLE_PARTNER_REQUEST,
  VENDOR_TOGGLE_PARTNER_SUCCESS,
  VENDOR_TOGGLE_PARTNER_FAILURE,
  VENDOR_TOGGLE_GLOBAL_INACTIVE_FILTER_SUCCESS,
  VENDORS_GET_VENDORS_BY_USER_REQUEST,
  VENDORS_GET_VENDORS_BY_USER_SUCCESS,
  VENDORS_GET_VENDORS_BY_USER_FAILURE,
  IMPORT_VENDOR_DETAILS_REQUEST,
  IMPORT_VENDOR_DETAILS_SUCCESS,
  IMPORT_VENDOR_DETAILS_FAILURE,
  IMPORT_VENDOR_DETAILS_SAVE_REQUEST,
  IMPORT_VENDOR_DETAILS_SAVE_SUCCESS,
  IMPORT_VENDOR_DETAILS_SAVE_FAILURE,
  RESET_IMPORT_VENDORS_SUCCESS,
  DOWNLOAD_VENDOR_IMPORT_TEMPLATE_SUCCESS,
  DOWNLOAD_VENDOR_IMPORT_TEMPLATE_FAILURE,
  RESET_ATTACHED_VENDORS_TO_USER,
  VENDOR_PRODUCT_DETAILS_SAVE_REQUEST,
  VENDOR_PRODUCT_SAVE_SUCCESS,
  VENDOR_PRODUCT_SAVE_FAILURE,
  VENDOR_PRODUCTS_LIST_SUCCESS,
  VENDOR_PRODUCTS_LIST_FAILURE,
  VENDOR_PRODUCT_DETAILS_SUCCESS,
  VENDOR_PRODUCT_DETAILS_FAILURE,
  VENDOR_PRODUCT_DETAILS_SAVE_SUCCESS,
  VENDOR_PRODUCT_DETAILS_SAVE_FAILURE,
  VENDOR_PRODUCT_UPLOAD_IMAGE_SUCCESS,
  VENDOR_PRODUCT_UPLOAD_IMAGE_FAILURE,
  GET_VENDOR_PRODUCT_IMAGE_SUCCESS,
  GET_VENDOR_PRODUCT_IMAGE_FAILURE,
  REMOVE_PRODUCT_IMAGE_SUCCESS,
  VENDORS_GET_FILTERS_SUCCESS,
  VENDORS_GET_FILTERS_FAILURE,
  VENDORS_SET_FILTERS_SUCCESS,
  VENDORS_SET_FILTERS_CLEAR,
  SET_QUERY_VALUE,
  VENDOR_LOGO_UPLOAD_SUCCESS,
  VENDOR_LOGO_UPLOAD_FAILURE,
  GET_VENDOR_LOGO_SUCCESS,
  GET_VENDOR_LOGO_FAILURE
} from './actions';

import _ from 'lodash';

import createReducer from 'state/createReducer';

const initialState = {
  request: false,
  errorMessage: null,
  filters: [],
  activeFilters: {},
  list: [],
  inventoryVendorsList: [],
  globalInactiveFilter: false,
  details: {
    request: false,
    vendorName: '',
    leadTimeDays: 0,
    referencePeriodDays: 0,
    valuesChanged: false,
    showConfirmModal: false,
    errorMessage: null,
    formFields: [],
    meta: [],
    attachedUsers: [],
    fulfilmentHubs: [],
    fulfilmentHubsSelected: [],
    fulfilmentHubsWithProducts: [],
    fulfilmentHubInformation: []
  },
  listByUser: [],
  saveRequest: false,

  saveImportRequest: false,
  importedFilename: '',
  importedVendorsChanges: [],

  productsList: [],
  productDetails: {},
  savedProductId: null,
  searchQuery: '',
  syncPending: [],
  logo: null
};

const handlers = {
  [VENDOR_TOGGLE_GLOBAL_INACTIVE_FILTER_SUCCESS](state, payload) {
    return {
      ...state,
      globalInactiveFilter: payload
    };
  },

  [VENDOR_TOGGLE_INACTIVE_REQUEST](state, payload) {
    const newList = [...state.list];

    const idx = _.findIndex(newList, (o) => {
      return o.id === payload.id;
    });
    if (idx === -1) {
      return {
        ...state
      };
    }

    newList[idx].inactiveRequest = true;

    return {
      ...state,
      list: newList
    };
  },

  [VENDOR_TOGGLE_INACTIVE_SUCCESS](state, payload) {
    const newList = [...state.list];

    const idx = _.findIndex(newList, (o) => {
      return o.id === payload.id;
    });
    if (idx === -1) {
      return {
        ...state
      };
    }

    newList[idx].inactiveRequest = false;
    newList[idx].isInactive = payload.inactive;

    return {
      ...state,
      list: newList
    };
  },

  [VENDOR_TOGGLE_INACTIVE_FAILURE](state, payload) {
    const newList = [...state.list];

    const idx = _.findIndex(newList, (o) => {
      return o.id === payload.id;
    });
    if (idx === -1) {
      return {
        ...state
      };
    }

    newList[idx].inactiveRequest = false;

    return {
      ...state,
      list: newList
    };
  },

  [VENDOR_TOGGLE_PARTNER_REQUEST](state, payload) {
    const newList = [...state.list];

    const idx = _.findIndex(newList, (o) => {
      return o.id === payload.id;
    });
    if (idx === -1) {
      return {
        ...state
      };
    }

    newList[idx].cellarxPartnerRequest = true;

    return {
      ...state,
      list: newList
    };
  },

  [VENDOR_TOGGLE_PARTNER_SUCCESS](state, payload) {
    const newList = [...state.list];

    const idx = _.findIndex(newList, (o) => {
      return o.id === payload.id;
    });
    if (idx === -1) {
      return {
        ...state
      };
    }

    newList[idx].cellarxPartnerRequest = false;
    newList[idx].isCellarxPartner = payload.isCellarXPartner;

    return {
      ...state,
      list: newList
    };
  },

  [VENDOR_TOGGLE_PARTNER_FAILURE](state, payload) {
    const newList = [...state.list];

    const idx = _.findIndex(newList, (o) => {
      return o.id === payload.id;
    });
    if (idx === -1) {
      return {
        ...state
      };
    }

    newList[idx].cellarxPartnerRequest = false;

    return {
      ...state,
      list: newList
    };
  },

  [VENDOR_DETAILS_TOGGLE_CONFIRM_MODAL](state, payload) {
    const newDetails = { ...state.details };
    newDetails.showConfirmModal = payload;

    return {
      ...state,
      details: newDetails
    };
  },

  [VENDOR_DETAILS_SAVE_REQUEST](state) {
    return {
      ...state,
      saveRequest: true
    };
  },

  [VENDOR_DETAILS_SAVE_SUCCESS](state) {
    return {
      ...state,
      saveRequest: false
    };
  },

  [VENDOR_DETAILS_SAVE_FAILURE](state, payload) {
    return {
      ...state,
      saveRequest: false,
      errorPayloadFulfilmentHub: payload
    };
  },

  [VENDOR_ONCHANGE_DETAILS](state, payload) {
    const newDetails = { ...state.details };
    newDetails.formFields[payload.gIdx].fields[payload.fIdx].value = payload.val;
    newDetails.valuesChanged = true;

    return {
      ...state,
      details: newDetails
    };
  },

  [VENDOR_DETAILS_CLEAR](state) {
    const initDetails = { ...state.details };
    initDetails.formFields = [];
    initDetails.request = false;
    initDetails.vendorName = '';
    initDetails.errorMessage = null;
    initDetails.valuesChanged = false;
    initDetails.showConfirmModal = false;
    initDetails.attachedUsers = [];
    initDetails.fulfilmentHubs = [];
    initDetails.fulfilmentHubsSelected = [];
    initDetails.fulfilmentHubsWithProducts = [];
    initDetails.fulfilmentHubInformation = [];

    return {
      ...state,
      details: initDetails
    };
  },

  [VENDOR_DETAILS_META_GET_SUCCESS](state, payload) {
    const newDetails = { ...state.details };
    newDetails.meta = payload;

    return {
      ...state,
      details: newDetails
    };
  },

  [VENDOR_DETAILS_GET_REQUEST](state) {
    const meta = { ...state.details.meta };

    return {
      ...state,
      details: {
        request: true,
        vendorName: '',
        valuesChanged: false,
        showConfirmModal: false,
        errorMessage: null,
        formFields: [],
        attachedUsers: [],
        fulfilmentHubs: [],
        fulfilmentHubsSelected: [],
        fulfilmentHubsWithProducts: [],
        fulfilmentHubInformation: [],
        meta: meta
      }
    };
  },

  [VENDOR_DETAILS_GET_SUCCESS](state, payload) {
    const meta = { ...state.details.meta };

    return {
      ...state,
      details: {
        request: false,
        valuesChanged: false,
        showConfirmModal: false,
        errorMessage: null,
        vendorName: payload.name,
        leadTimeDays: payload.leadTimeDays,
        referencePeriodDays: payload.referencePeriodDays,
        formFields: payload.data,
        attachedUsers: payload.attachedUsers,
        fulfilmentHubs: payload.fulfilmentHubs,
        fulfilmentHubsSelected: payload.fulfilmentHubsSelected,
        fulfilmentHubsWithProducts: payload.fulfilmentHubsWithProducts,
        fulfilmentHubInformation: payload.fulfilmentHubInformation,

        meta: meta
      }
    };
  },

  [VENDOR_DETAILS_GET_FAILURE](state, payload) {
    const newDetails = { ...state.details };
    newDetails.request = false;
    newDetails.errorMessage = payload.errorMessage;

    return {
      ...state,
      details: newDetails
    };
  },

  [VENDORS_LIST_REQUEST](state) {
    return {
      ...state,
      request: true,
      errorMessage: null
    };
  },

  [VENDORS_LIST_SUCCESS](state, payload) {
    let data = payload;
    if (data === null) {
      data = [];
    }

    for (let i = 0; i < data.length; i++) {
      data[i].request = false;
    }

    return {
      ...state,
      request: false,
      errorMessage: null,
      list: data
    };
  },

  [VENDORS_LIST_FAILURE](state, payload) {
    return {
      ...state,
      request: false,
      errorMessage: payload.errorMessage
    };
  },

  [VENDOR_GET_FULFILMENT_HUBS_SUCCESS](state, payload) {
    return {
      ...state,
      fulfilmentHubs: payload
    };
  },
  [VENDOR_GET_FULFILMENT_HUBS_FAILURE](state, payload) {
    return {
      ...state,
      errorMessage: payload.errPayload
    };
  },
  [VENDORS_GET_VENDORS_BY_USER_REQUEST](state) {
    return {
      ...state,
      request: true,
      errorMessage: null
    };
  },

  [VENDORS_GET_VENDORS_BY_USER_SUCCESS](state, payload) {
    let data = payload;
    if (data === null) {
      data = [];
    }

    for (let i = 0; i < data.length; i++) {
      data[i].request = false;
    }

    return {
      ...state,
      request: false,
      errorMessage: null,
      listByUser: data
    };
  },

  [VENDORS_GET_VENDORS_BY_USER_FAILURE](state, payload) {
    return {
      ...state,
      request: false,
      errorMessage: payload.errorMessage
    };
  },

  [RESET_ATTACHED_VENDORS_TO_USER](state, payload) {
    return {
      ...state,
      request: false,
      errorMessage: null,
      listByUser: []
    };
  },

  [IMPORT_VENDOR_DETAILS_REQUEST](state) {
    return {
      ...state,
      request: true,
      errorMessage: null
    };
  },

  [IMPORT_VENDOR_DETAILS_SUCCESS](state, payload) {
    return {
      ...state,
      request: false,
      errorMessage: null,
      importedFilename: payload.Filename,
      importedVendorsChanges: payload.Vendors
    };
  },

  [IMPORT_VENDOR_DETAILS_FAILURE](state, payload) {
    return {
      ...state,
      request: false,
      errorMessage: payload.errorMessage
    };
  },

  [IMPORT_VENDOR_DETAILS_SAVE_REQUEST](state) {
    return {
      ...state,
      saveImportRequest: true,
      errorMessage: null,
      importedVendorsChanges: []
    };
  },

  [IMPORT_VENDOR_DETAILS_SAVE_SUCCESS](state, payload) {
    return {
      ...state,
      saveImportRequest: false,
      errorMessage: null
    };
  },

  [IMPORT_VENDOR_DETAILS_SAVE_FAILURE](state, payload) {
    return {
      ...state,
      saveImportRequest: false,
      errorMessage: payload.errorMessage
    };
  },

  [RESET_IMPORT_VENDORS_SUCCESS](state, payload) {
    return {
      ...state,
      saveImportRequest: false,
      request: false,
      errorMessage: null,
      importedFilename: '',
      importedVendorsChanges: []
    };
  },

  [DOWNLOAD_VENDOR_IMPORT_TEMPLATE_SUCCESS](state, payload) {
    const url = window.URL.createObjectURL(
      new Blob([payload.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
    );
    var link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', payload.filename);
    document.body.appendChild(link);
    link.click();

    return {
      ...state
    };
  },

  [DOWNLOAD_VENDOR_IMPORT_TEMPLATE_FAILURE](state) {
    return {
      ...state
    };
  },

  [VENDOR_PRODUCT_SAVE_SUCCESS](state, payload) {
    return {
      ...state,
      savedProductId: payload
    };
  },

  [VENDOR_PRODUCT_SAVE_FAILURE](state, payload) {
    return {
      ...state,
      errorMessage: payload.errorMessage
    };
  },

  [VENDOR_PRODUCTS_LIST_SUCCESS](state, payload) {
    let list = [];
    if (payload !== null) {
      list = payload;
    }

    return {
      ...state,
      request: false,
      errorMessage: null,
      productsList: list
    };
  },

  [VENDOR_PRODUCTS_LIST_FAILURE](state, payload) {
    return {
      ...state,
      errorMessage: payload.errorMessage
    };
  },

  [VENDOR_PRODUCT_DETAILS_SAVE_REQUEST](state, payload) {
    if (state.syncPending.includes(payload) === true) {
      return {
        ...state
      };
    }

    const pending = [...state.syncPending];
    pending.push(payload);

    return {
      ...state,
      syncPending: pending
    };
  },

  [VENDOR_PRODUCT_DETAILS_SUCCESS](state, payload) {
    return {
      ...state,
      productDetails: payload
    };
  },

  [VENDOR_PRODUCT_DETAILS_FAILURE](state, payload) {
    return {
      ...state,
      errorMessage: payload.errorMessage
    };
  },

  [VENDOR_PRODUCT_DETAILS_SAVE_SUCCESS](state, payload) {
    if (state.syncPending.includes(payload) === false) {
      return {
        ...state
      };
    }

    const pending = [...state.syncPending];
    const idx = _.findIndex(pending, (o) => {
      return o == payload;
    });

    pending.splice(idx, 1);

    return {
      ...state,
      syncPending: pending
    };
  },

  [VENDOR_PRODUCT_DETAILS_SAVE_FAILURE](state, payload) {
    if (state.syncPending.includes(payload.id) === false) {
      return {
        ...state
      };
    }

    const pending = [...state.syncPending];
    const idx = _.findIndex(pending, (o) => {
      return o == payload.id;
    });

    pending.splice(idx, 1);

    return {
      ...state,
      errorMessage: payload.error.errorMessage,
      syncPending: pending
    };
  },

  [VENDOR_PRODUCT_UPLOAD_IMAGE_SUCCESS](state, payload) {
    return {
      ...state,
      savedProductId: null
    };
  },

  [VENDOR_PRODUCT_UPLOAD_IMAGE_FAILURE](state, payload) {
    return {
      ...state,
      errorMessage: payload.errorMessage
    };
  },

  [GET_VENDOR_PRODUCT_IMAGE_SUCCESS](state, payload) {
    let arrayBuffer = payload.data;

    let bytes = new Uint8Array(arrayBuffer);
    if (bytes.length > 0) {
      return {
        ...state,
        imageContent: 'data:image;base64,' + encode(bytes)
      };
    } else {
      return {
        ...state,
        imageContent: null
      };
    }
  },

  [GET_VENDOR_PRODUCT_IMAGE_FAILURE](state, payload) {
    return {
      ...state,
      errorMessage: payload.errorMessage
    };
  },

  [REMOVE_PRODUCT_IMAGE_SUCCESS](state, payload) {
    return {
      ...state,
      imageContent: null
    };
  },

  [VENDORS_GET_FILTERS_SUCCESS](state, payload) {
    let activeFilters = { ...state.activeFilters };

    payload.meta.availableFilters.forEach((v) => {
      if (Array.isArray(activeFilters[v.queryStringCode]) === false) {
        activeFilters[v.queryStringCode] = [];
      }
    });

    return {
      ...state,
      activeFilters: activeFilters,
      filters: payload
    };
  },

  [VENDORS_GET_FILTERS_FAILURE](state, payload) {
    return {
      ...state,
      errorMessage: payload.errorMessage
    };
  },

  [VENDORS_SET_FILTERS_SUCCESS](state, payload) {
    return {
      ...state,
      activeFilters: payload
    };
  },

  [VENDORS_SET_FILTERS_CLEAR](state) {
    const activeFilters = { ...state.activeFilters };

    Object.keys(activeFilters).forEach((v) => {
      activeFilters[v] = [];
    });

    return {
      ...state,
      activeFilters: activeFilters,
      globalInactiveFilter: false
    };
  },

  [VENDOR_ONCHANGE_INFO](state, payload) {
    const newDetails = { ...state.details };
    newDetails[payload.key] = payload.value;

    return {
      ...state,
      details: newDetails
    };
  },

  [SET_QUERY_VALUE](state, payload) {
    const lq = payload.toLowerCase();
    return {
      ...state,
      searchQuery: lq
    };
  },
  [VENDOR_LOGO_UPLOAD_SUCCESS](state) {
    return {
      ...state
    };
  },
  [VENDOR_LOGO_UPLOAD_FAILURE](state, payload) {
    return {
      ...state,
      errorMessage: payload.errorMessage
    };
  },

  [GET_VENDOR_LOGO_SUCCESS](state, payload) {
    const logo = URL.createObjectURL(new Blob([payload]));
    return {
      ...state,
      logo: logo
    };
  },
  [GET_VENDOR_LOGO_FAILURE](state, payload) {
    return {
      ...state,
      logo: null,
      errorMessage: payload.errorMessage
    };
  }
};

function encode(input) {
  var keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  var output = '';
  var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
  var i = 0;

  while (i < input.length) {
    chr1 = input[i++];
    chr2 = i < input.length ? input[i++] : Number.NaN; // Not sure if the index
    chr3 = i < input.length ? input[i++] : Number.NaN; // checks are needed here

    enc1 = chr1 >> 2;
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
    enc4 = chr3 & 63;

    if (isNaN(chr2)) {
      enc3 = enc4 = 64;
    } else if (isNaN(chr3)) {
      enc4 = 64;
    }
    output += keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
  }
  return output;
}

export default (state = initialState, action) => createReducer(state, action, handlers);
